import React from 'react'

interface IProps {
  items: string[]
  value?: string
  onChange?: (value: string) => void
  className?: string
}

function SelectBtns(props: IProps): React.ReactElement {
  const [value, setValue] = React.useState(props.value)
  React.useEffect(() => {
    setValue(props.value)
  }, [props.value])

  return (
    <div className={`select-btns ${props.className}`.trim()}>
      {props.items.map((item) => {
        return (
          <button
            key={item}
            type="button"
            className={`select-btns__item ${
              value === item ? '_active' : ''
            }`.trim()}
            onClick={() => {
              setValue(item)
              props.onChange?.(item)
            }}
          >
            {item}
          </button>
        )
      })}
    </div>
  )
}

export default SelectBtns
